import axios from 'axios'

export const signupUser = async (formData) => {
    const signupUrl = process.env.REACT_APP_SIGNUP_URL;
    const xApiKey = process.env.REACT_APP_X_API_KEY;
    const requestConfig = {
        headers: {
            'x-api-key': xApiKey
        }
    };
    try {
        const response = await axios.post(signupUrl, formData, requestConfig);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const loginUser = async (formData) => {
    const loginUrl = process.env.REACT_APP_LOGIN_URL;
    const requestConfig = {
        headers: {
            'x-api-key': process.env.REACT_APP_X_API_KEY
        }
    }
    const requestBody = formData
    try {
        const response = await axios.post(loginUrl, requestBody, requestConfig);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const verifyToken = async (userInfo, token) => {
    const verifyUrl = process.env.REACT_APP_VERIFY_URL;
    const requestConfig = {
        headers: {
            'x-api-key': process.env.REACT_APP_X_API_KEY
        }
    }
    const requestBody = { userInfo, token }
    return axios.post(verifyUrl, requestBody, requestConfig).then(response => {
        return response.data;
    }).catch(error => {
        throw error
    })
}
